import React, { useEffect, useState } from 'react'
import { HubTitle } from '../styles'
import { getFeedByTag, FeedItem } from '../../../Api'
import { FeedCardList } from '../../../Components/Feed'
type MediaProps = {
  tag: string
}

export const Media: React.FC<React.PropsWithChildren<MediaProps>> = ({ tag }) => {
  const [feed, setFeed] = useState<FeedItem[]>([])

  useEffect(() => {
    if (tag) {
      getNews()
    }
  }, [])

  const getNews = async () => {
    let params = {
      tags: [tag],
      includeVideo: true,
    }
    const feedItems = await getFeedByTag(params)
    if (!feedItems) return
    setFeed(feedItems?.length > 0 ? feedItems : [])
  }

  return (
    <>
      {feed.length > 0 && (
        <>
          <HubTitle>News</HubTitle>
          <FeedCardList feedItems={feed} section={'event_hub_team_media'} />
        </>
      )}
    </>
  )
}
